import { MODULE_ACHAT, SOUS_TYPE_NORMAL } from '@/configuration/devisConf';
import { TYPE_REFERENCE_EXTERNE_VENTE } from '@/configuration/dcf/dcfConf';

export default function genererCritereRecherche() {
  return {
    auto: null,
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    etat: [],
    code: null,
    tiersId: [],
    produitsIds: [],
    societeId: null,
    commandeId: null,
    typeReferenceExterne: TYPE_REFERENCE_EXTERNE_VENTE,
    module: MODULE_ACHAT,
    sousType: [SOUS_TYPE_NORMAL],
    referenceExterne: null,
  };
}
